import React, {FC, useState} from "react";
import {IdentificationBlock} from "../../index";
import {Button, Checkbox, ColoredText, Heading, InputErrors, PrimaryButton, SecondaryHeading} from "../../../../common";
import {HeadingType} from "../../../../common/typography/headings/Heading/Heading";
import {PrimaryButtonColor} from "../../../../common/buttons/decorators/PrimaryButton/PrimaryButton";
import {Errors as ValidationErrors,} from "../../../../../utils";
import {useEffectOnUpdate, useProfileData} from "../../../../../hooks";
import {TextColor} from "../../../../common/typography/texts/ColoredText/ColoredText";

export type IdentificationConclusionErrors = {
  rulesAccepted?: ValidationErrors;
  personalPolicy?: ValidationErrors;
  reglament?: ValidationErrors;
  documentsCopy?: ValidationErrors;
}

interface Props {
    dataValid: boolean;
    loading: boolean;
    submitDisabled?: boolean;
}

export const IdentificationConclusionBorrower: FC<Props> = ({dataValid, loading, submitDisabled = false}) => {
  const [rulesAccepted, setRulesAccepted] = useState(false);
  const [personalPolicy, setPersonalPolicy] = useState(false);
  const [reglament, setReglament] = useState(false);
  const [documentsCopy, setDocumentsCopy] = useState(false);
  const [errors, setErrors] = useState<IdentificationConclusionErrors>({});
  const profileData = useProfileData();
  const isVerified = () => {
    return profileData.isVerified;
  };

  const validateBlock = (): boolean => {
    const errors: IdentificationConclusionErrors = {};
    if (!rulesAccepted) {
      errors.rulesAccepted = ["Для продолжения работы на Платформе вам необходимо дать согласие\n"];
    }
    if (!personalPolicy) {
      errors.personalPolicy = ["Для продолжения работы на Платформе вам необходимо дать согласие\n"];
    }
    if (!reglament) {
      errors.reglament = ["Для продолжения работы на Платформе вам необходимо дать согласие\n"];
    }
    if (!documentsCopy) {
      errors.documentsCopy = ["Для продолжения работы на Платформе вам необходимо дать согласие\n"];
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffectOnUpdate(() => {
    validateBlock();
  }, [rulesAccepted, personalPolicy, reglament, documentsCopy]);

  const canSubmit = dataValid && rulesAccepted && personalPolicy && reglament && documentsCopy;

  return (
    <>
      <IdentificationBlock>
        <SecondaryHeading>
          <Heading headingType={HeadingType.H2}>
            Подтверждения
          </Heading>
        </SecondaryHeading>
        <p>
          Подтверждая данные анкеты с помощью Простой электронной подписи в рамках статьи 431.2. «Заверение об
          обстоятельствах» Инвестор подтверждает Оператору Платформы следующие факты:
        </p>
        {!isVerified() && <div className="form__group">
          <div className="form__group"><Checkbox
            onChange={() => setPersonalPolicy((personalPolicy) => !personalPolicy)}
            id={'personalPolicy'}>
            Предоставление <ColoredText color={TextColor.PRIMARY_GREEN}><a
              href={'https://cdn.conomica-finance.ru/file/31705/521/16b9-80df0/soglasie-na-obrabotku-personalnyx-dannyx-1.pdf'} target="_blank"
              rel="noopener noreferrer">
              Согласия на обработку персональных данных
            </a></ColoredText> в соответствии с <ColoredText
              color={TextColor.PRIMARY_GREEN}><a
                href="https://cdn.conomica-finance.ru/file/31705/521/1476-66e57/politika-obrabotki-personalnyx-dannyx.pdf" target="_blank"
                rel="noopener noreferrer">
                Политикой обработки персональных данных
              </a></ColoredText>
          </Checkbox> {errors.personalPolicy && <InputErrors errors={errors.personalPolicy}/>}</div>
          <div className="form__group"><Checkbox
            onChange={() => setDocumentsCopy((documentsCopy) => !documentsCopy)}
            id={'documentsCopy'}>
            Копии документов, предоставленных в рамках Верификационной Анкеты, являются достоверными и
            сделаны лично инвестором с оригинала документа. Данные, указанные на странице Верификации,
            являются достоверными
          </Checkbox> {errors.documentsCopy && <InputErrors errors={errors.documentsCopy}/>}</div>

          <div className="form__group"><Checkbox
            onChange={() => setRulesAccepted((rulesAccepted) => !rulesAccepted)}
            id={'rulesAccepted'}>
            Заемщик подтверждает своё волеизъявление заключить «Договор о содействии в привлечении
            инвестиций» на условиях, указанных в <ColoredText color={TextColor.PRIMARY_GREEN}><a
              href="https://cdn.conomica-finance.ru/file/31706/7e3/1262-77410/pravila-investicionnoi-platformy-konomika-zaimy-dlya-biznesa2.pdf" target="_blank"
              rel="noopener noreferrer">
              Правилах Платформы
            </a></ColoredText>
          </Checkbox> {errors.rulesAccepted && <InputErrors errors={errors.rulesAccepted}/>}</div>
          <div className="form__group"><Checkbox onChange={() => setReglament((reglament) => !reglament)}
            id={'reglament'}>
            Ознакомлен и согласен с <ColoredText color={TextColor.PRIMARY_GREEN}>
              <a href="https://cdn.conomica-finance.ru/file/31705/523/008e-c695d/reglament-raboty-s-prosrocennoi-zadolzennostyu.pdf" target="_blank"
                rel="noopener noreferrer"> Регламентом работы с просроченной задолженностью </a></ColoredText> и  <ColoredText color={TextColor.PRIMARY_GREEN}>
              <a href="https://cdn.conomica-finance.ru/file/31710/5ec/1612-ad9f7/pravila-raboty-s-dogovorami-obespeceniya.pdf" target="_blank"
                rel="noopener noreferrer">Правилами работы с договорами обеспечения </a></ColoredText>
          </Checkbox> {errors.reglament && <InputErrors errors={errors.reglament}/>}</div>
        </div>
        }
        <div className="form__group">
          <PrimaryButton expanded large color={PrimaryButtonColor.GREEN}>
            <Button type={"submit"} disabled={submitDisabled || loading || (isVerified() ? !dataValid : !canSubmit)}>
              {isVerified() ? "Подтвердить изменения"
                : "Запросить ключ электронной подписи"}
            </Button>
          </PrimaryButton>
        </div>
      </IdentificationBlock>
    </>

  )
  ;
};